export default __webpack_public_path__ + "static/media/list.37ad9cd8.svg";